'use client';

import React from 'react';
import { cn } from '@/shared/lib/cn';

interface PulsingDotsProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function PulsingDots({ className, size = 'md' }: PulsingDotsProps) {
  const sizeClasses = {
    sm: 'w-2 h-2',
    md: 'w-3 h-3',
    lg: 'w-4 h-4',
  };

  const gapClasses = {
    sm: 'gap-1.5',
    md: 'gap-2',
    lg: 'gap-2.5',
  };

  return (
    <div className={cn('flex items-center', gapClasses[size], className)}>
      <span
        className={cn(
          sizeClasses[size],
          'rounded-full bg-current animate-pulse',
          '[animation-delay:0ms]'
        )}
      />
      <span
        className={cn(
          sizeClasses[size],
          'rounded-full bg-current animate-pulse',
          '[animation-delay:200ms]'
        )}
      />
      <span
        className={cn(
          sizeClasses[size],
          'rounded-full bg-current animate-pulse',
          '[animation-delay:400ms]'
        )}
      />
    </div>
  );
}
